import { Survey } from "@/types";
import { useDateFormatter, useTranslations } from "@/contexts/Translation";
import { InvisibleLink } from "../Link/Link";
import ProfileImage from "../ProfileImage";
import EmScore from "../Survey/EmScore";
import { surveyShortTitle } from "../Survey/Surveys";
import { CategoryScores, lowestCategory } from "./insights";
import { categoryLabel, surveyTypeLabel } from "./labels";
import styles from "./Index.module.css";

const SurveyRow = ({ survey, scores }: { survey: Survey; scores?: CategoryScores }) => {
  const t = useTranslations("surveys");
  const d = useDateFormatter();
  const lowest = lowestCategory(scores);
  const hasAnswers = (survey.respondents || 0) > 0 && !!scores && Object.keys(scores).length > 0;

  return (
    <InvisibleLink className={styles.surveyRow} href={`/survey/${survey.id}`}>
      <ProfileImage src={survey.profileImage ? `/files/profile/${survey.profileImage}` : ""} variant='small' alt={survey.candidate} />
      <div className={styles.surveyInfo}>
        <h3 className={styles.rowTitle}>{surveyShortTitle(survey, t, d)}</h3>
        <p className={styles.rowMeta}>
          <span>{t(surveyTypeLabel(survey.surveyType))}</span>
          <span>{t("start", d(survey.startDate))}</span>
          <span>{t("respondents", survey.respondents || 0, Math.max(survey.invited || 0, survey.respondents || 0))}</span>
          <span className={styles.tag}>{t(`status_${survey.status}`)}</span>
        </p>
        {hasAnswers && (
          <ul className={styles.chips}>
            {Object.entries(scores).map(([question, score]) => (
              <li key={question} className={question === lowest ? styles.chipLowest : styles.chip}>
                {t(categoryLabel(question))} {score.toFixed(1)}
              </li>
            ))}
          </ul>
        )}
      </div>
      <EmScore size={3.25} status={survey.status} score={survey.score} />
    </InvisibleLink>
  );
};

export default SurveyRow;
